import { styled } from '@mui/material';

const Main = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'hidden',
  minHeight: '100%',
  paddingTop: '10px',
  paddingBottom: theme.spacing(0),
  [theme.breakpoints.up('lg')]: {
    // paddingTop: '10px',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(0)
  }
}));

export default Main;
